import { useEffect, useRef } from "react";
import { GetReactionIcon } from "../../../../Shared/Components/Tippspiel/Reactions/ReactionsIconsFactory";
import {
    ReactedUserItem,
    ReactedUserName,
    ReactedUsersTabPanel,
    ReactedUserReaction,
} from "./ReactionsListModal.styles";
import { UserAvatarFactory } from "../../../UserAvatar/UserAvatarFactory";
import { Reactions, TabPanelProps } from "./ReactionsListModal.types";
import SwipeableViews from "react-swipeable-views";

export function ReactionsListTabsContent({
    onChange,
    tabs,
    tabIndex,
}: {
    onChange: (item: number) => void;
    tabIndex: number;
    tabs: Reactions[];
}) {
    const modalContentRef = useRef<HTMLDivElement>();
    useEffect(() => {
        if (modalContentRef.current) {
            modalContentRef?.current?.scrollTo(0, 0);
        }
    }, [tabIndex]);
    return (
        <SwipeableViews axis={"x"} index={tabIndex} onChangeIndex={onChange}>
            {tabs.map((tab, index) => (
                <CustomTabPanel key={tab.type} value={tabIndex} index={index}>
                    {tab.users.map((item) => (
                        <ReactedUserItem
                            key={`${item.uuid}-${item.reactionType}`}
                        >
                            <UserAvatarFactory
                                uuid={item.uuid}
                                avatar={item.avatar}
                                gender={item.gender}
                            />
                            <ReactedUserReaction>
                                <GetReactionIcon
                                    reactionName={item.reactionType}
                                    sx={{
                                        width: "16px",
                                        height: "16px",
                                    }}
                                />
                            </ReactedUserReaction>
                            <ReactedUserName>{item.screenName}</ReactedUserName>
                        </ReactedUserItem>
                    ))}
                </CustomTabPanel>
            ))}
        </SwipeableViews>
    );
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} {...other}>
            {value === index && (
                <ReactedUsersTabPanel>{children}</ReactedUsersTabPanel>
            )}
        </div>
    );
}
